import React from "react";

const SidebarSkeleton: React.FC = () => {
  return (
    <div
      className="flex text-sm 2xl:text-base animate-pulse"
      data-testid="sidebar-skeleton"
    >
      <div className="flex flex-col max-h-screen h-screen p-4 bg-gray-50 shadow w-72 2xl:w-80 flex-shrink-0">
        {/* Logo */}
        <div className="flex items-center justify-center space-x-2 mb-4 py-2 cursor-pointer">
          <div className="w-[250px] h-[150px] bg-gray-300 rounded-md" />
        </div>

        {/* Static Nav Links */}
        <div className="flex flex-col space-y-2 mb-4">
          {[...Array(5)].map((_, i) => (
            <div key={i} className="h-12 bg-gray-200 rounded-md" />
          ))}
        </div>

        {/* Projects List */}
        <div className="flex-1 overflow-y-auto custom-scroll space-y-2 mb-4"></div>

        {/* Evaluation Link */}
        <div className="h-12 bg-gray-200 rounded-md mb-4" />

        {/* User Info */}
        <div className="bg-gray-200 text-white p-4 px-4 rounded-lg flex items-center justify-between text-xs 2xl:text-sm">
          <div className="flex items-center space-x-3 w-full">
            <div className="w-10 h-10 bg-gray-300 rounded-full border border-gray-300" />
            <div className="space-y-1 w-full">
              <div className="w-24 h-3 bg-gray-300 rounded" />
              <div className="w-32 h-3 bg-gray-300 rounded" />
              <div className="w-16 h-3 bg-gray-300 rounded" />
            </div>
          </div>
        </div>

        {/* Sign Out Button */}
        <div className="mt-4 w-full h-11 bg-gray-300 rounded" />
      </div>
    </div>
  );
};

export default SidebarSkeleton;
